var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgNoAvatar = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 120,
    fill: "none",
    viewBox: "0 0 106 120",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C1CBD6",
    d: "M53 0C35.553 0 21.36 14.194 21.36 31.64c0 17.447 14.193 31.641 31.64 31.641 17.447 0 31.64-14.194 31.64-31.64C84.64 14.194 70.448 0 53 0zM92.367 83.952c-8.663-8.796-20.146-13.64-32.336-13.64H45.97c-12.19 0-23.674 4.844-32.336 13.64C5.013 92.704.266 104.258.266 116.484.266 118.426 1.84 120 3.78 120h98.438c1.941 0 3.515-1.574 3.515-3.516 0-12.226-4.747-23.78-13.367-32.532z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNoAvatar, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/no_avatar.dd6cec3c.svg";
export { ForwardRef as ReactComponent };